<template>
  <div style="display: inline-flex">

    <Button :label="$t('library.cycle.share_button')" 
      class="p-button-outlined" icon="icon-share" iconPos="left" 
      @click="buttonClick" />

    <Dialog :visible="dialog.share" class="recipe-share-dialog" :modal="true" 
        :closable="true" :dismissableMask="true" :style="{width: '500px', minWidth: '460px'}" :draggable="false"
        @update:visible="updateVisible">
        
      <template #header>&nbsp;</template>
      
      <div>
        <div class="p-d-flex p-jc-center p-mb-1">
          <span class="icon-share" style="font-size: 50px"/>
        </div>
        <div class="title p-d-flex p-jc-center">
          {{$t('library.cycle.share_dialog_title')}}
        </div>
      </div>

      <div class="library-share-cycle p-mt-5">

        <div v-if="step==1">
          <div v-for="(lab, index) in labs" :key="lab" @click="selectLab(lab)" :tabindex="index">
            {{lab.name ?? $t('library.cycle.share_no_lab')}}
          </div>
        </div>

        <div v-if="step==2">
          <span v-if="(filteredAppliances.length==0)">{{$t('dashboard.filter_no_appliances')}}</span>
          <div v-else v-for="(app, index) in filteredAppliances" :key="app" @click="selectAppliance(app)" :class="{'disabled':isApplianceNotSelectable(app)}" :tabindex="index"
              v-tooltip.bottom="{
                value: tooltipMessage(app),
                disabled: !isApplianceNotSelectable(app),
                escape: true,
              }">
            {{app.name ?? app.serialNumber}} - {{app.modelNumber}}
          </div>
        </div>

      </div>

      <template #footer></template>
      
    </Dialog>

    <IrinoxDialogDark :visible="dialog.shareConfirm" mode="confirm" 
      :leftB="$t('library.cycle.share_dialog_cancel')" @click:left-button="() => {dialog.shareConfirm = false;}" 
      :rightB="$t('library.cycle.share_dialog_confirm')" @click:right-button="shareRecipe" 
      :message="$t('library.cycle.share_dialog')"
      icon="assets/irinox/icons/share_big.svg" />

    <!--                    -->
    <!-- ERRORS and SUCCESS -->
    <!--                    -->
    <IrinoxDialogDark :visible="dialog.error" 
      mode="error" 
      :message="$t('library.dialog_error')"
      :life="3000" 
      @update:visible="dialog.error = $event" />
    <IrinoxDialogDark :visible="dialog.success" 
      mode="success" 
      :message="$t('library.cycle.share_dialog_shared')"
      :life="3000" 
      @update:visible="dialog.success = $event" />

  </div>

</template>

<script>
import RecipeService from '../../../service/RecipeService';
import ApplianceService from '../../../service/ApplianceService';
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';
import { mapGetters } from 'vuex';

export default {

  components: {
      IrinoxDialogDark,
    },
    props: {
      serialNumber: String,
      recipe: Object,
      appliance: Object
    },
    data() {
        return {
          dialog: {
            error: false,
            share: false,
            shareConfirm: false,
            success: false
          },
          step: 1,
          labs: [],
          filteredAppliances: [],
          selectedAppliance: null
        };
    },
    computed: {
      ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          isCelsius: 'userdata/isCelsius',
          appliances: 'appliances/appliances'
        }),
    },
    watch: {
    },
    created() {
      this.recipeService = new RecipeService();
      this.applianceService = new ApplianceService();
    },
    mounted() {
    },
    methods: {
      buttonClick() {
        this.step = 1;
        this.filteredAppliances = [];
        this.dialog.share = true;
        this.getLabs();
      },
      updateVisible(value) {
        if(!value) {
          this.dialog.share = false;
        }
      },
      getLabs() {
        this.applianceService.getLabs(this.personaltoken)
          .then(labs => {
            this.populateLabs(labs);
            this.reloadAppliances();
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.share = false;
            this.dialog.error = true;
          });
      },
      populateLabs(labs) {
        this.labs = labs;
        this.labs.sort((a,b) => this.$functions.compareStrings(a, b, "name"));
        this.labs.push({name: null, id: null});
      },
      reloadAppliances() {
        this.applianceService.getAppliances(this.personaltoken)
          .then((appliances) => {
            this.$store.commit('appliances/appliances', appliances);
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.dialog.share = false;
            this.dialog.error = true;
          });
      },
      selectLab(lab) {
        this.filteredAppliances = this.appliances.filter(function(val) {
          return val.labName === lab.name && val.cycleLibrary === true;
        }.bind(this));
        this.step = 2;
      },
      selectAppliance(app) {
        if(this.isApplianceNotSelectable(app)) {
          return;
        }
        this.dialog.share = false;
        this.selectedAppliance = app;
        this.dialog.shareConfirm = true;
      },
      isApplianceNotSelectable(app) {
        return this.isDeviceOffline(app) || this.isDeviceNotCompatible(app);
      },
      isDeviceOffline(app) {
        return !app.online;
      },
      isDeviceNotCompatible(app) {
        if(this.recipe.package>0) {
          if(app._package==null) {
            //Macchina senza package
            return true;
          } else if(app._package===1) {
            //Macchina essential
            if(this.recipe.package===1) {
              return false;
            } else {
              return true;
            }
          } else if(app._package===6) {
            //Macchina pro --> senza Essicazione (12)
            if([0,1,2,3,4,5,6,7,8,9,10,11,13,14,15].includes(this.recipe.function)) {
              return false;
            } else {
              return true;
            }
          } else {
            //Macchina excellence (pkg 5) --> Marinatura (15) solo se firmware >= v7.7
            if(this.recipe.function === 15) {
              const marinaturaThreshold = "v7.7";
              const fw = app?.currentSoftwareVersion ?? null;
              
              if (fw === null) return true; // Conservativo
              return this.$functions.compareVersionStrings(fw, marinaturaThreshold) < 0; // Incompatibile se < v7.7
            }
            
            return ![0,1,2,3,4,5,6,7,8,9,10,11,12,13,14].includes(this.recipe.function);
          }
        } else {
          return true;
        }
      },
      tooltipMessage(app) {
        if(this.isDeviceNotCompatible(app)) {
          return this.$t('library.device_not_compatible');
        }
        if(this.isDeviceOffline(app)) {
          return this.$t('library.device_offline');
        }
        return "N/A";
      },
      shareRecipe() {
        this.dialog.shareConfirm = false;
        this.recipeService.shareRecipe(this.personaltoken, this.recipe.id, this.selectedAppliance.serialNumber)
          .then((data) => {
            if(data.code=="200") {
              this.dialog.success = true;
            } else {
              this.dialog.error = true;
              console.error("EXCEPTION "+JSON.stringify(data));
            }
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.dialog.error = true;
          });
      }
    }

}
</script>

<style scoped>

</style>